import {marked} from 'marked';
import {FilterXSS, getDefaultWhiteList} from 'xss';

const markedOptions = {
    gfm: true,
    tables: true,
    breaks: true,
};

const needSanitize = window.YC?.safeHtmlContent ?? true;

const filterAllHtmlConfig = {
    whiteList: {
        a: ['href', 'target'],
    },
};
const filterXss = new FilterXSS(filterAllHtmlConfig);

const whiteList = getDefaultWhiteList();
if (!whiteList.ol || !Array.isArray(whiteList.ol)) {
    whiteList.ol = [];
}
if (!whiteList.ol.includes('start')) {
    whiteList.ol.push('start');
}

const filterMarkdownXss = new FilterXSS({whiteList});

const parseMarkdown = (text: string) => {
    try {
        return marked.parse(text, markedOptions);
    } catch {
        return text;
    }
};

export const markdownToHTML = (text: string) => {
    if (!text) return '';

    if (needSanitize) {
        //filter all html in user input
        const safeText = filterXss.process(text);
        //format text markdown to html
        const formattedText = parseMarkdown(safeText);
        //filter xss in final formatted text
        return filterMarkdownXss.process(formattedText);
    }

    return parseMarkdown(text);
};
